import { BorerShiftDocument } from '../BorerShift/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SignatureDocument } from '../Signature/rxdbSignatureDefinition';
import {
  BorerShiftSignatureDocument,
  borerShiftSignaturePullQueryBuilder,
  borerShiftSignaturePushQueryBuilder,
} from './queryBuilder';

export function borerShiftSignatureFamilyMember(
  configBuilder: ConfigBuilder,
  borerShifts: FamilyMember<BorerShiftDocument>,
  signatures: FamilyMember<SignatureDocument>,
): FamilyMember<BorerShiftSignatureDocument> {
  const syncConfig = configBuilder<BorerShiftSignatureDocument>(
    RxdbCollectionNameV2.BORER_SHIFT_SIGNATURE,
  );
  doNotAutoSync(syncConfig);
  syncConfig.retryTime = 7500;

  pull(syncConfig, borerShiftSignaturePullQueryBuilder);
  push(syncConfig, borerShiftSignaturePushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_SHIFT_SIGNATURE, replicationState, [
    borerShifts,
    signatures,
  ]);
}
